<template>
  <div>
    <search :change="change" class="search"></search>
    <div class="content">
      <!-- <card-wk :data="wkData"></card-wk>
      <card-txk :data="txkData"></card-txk> -->
      <div>
        <card-course v-for="item in list" :key="item.id" :data="item"></card-course>
      </div>
      <no-search-data v-if="(!wkData.length && !txkData.length && !list.length )&&first"></no-search-data>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import Loading from 'components/base/loading/loading2'
import NoSearchData from 'components/base/loading/no-search-data'
import Search from 'components/search/search'
// import CardWk from './card-wk.vue'
// import CardTxk from './card-txk.vue'
import CardCourse from '../card/card-course'
import {RES_OK} from '@/api/config'
import {getJpList} from '@/api/jp.js'
export default {
  components: {
    Loading,
    NoSearchData,
    Search,
    // CardWk,
    // CardTxk,
    CardCourse
  },
  data() {
    return {
      page: 1,
      keyword: '',
      first: false,
      wkData: [],
      txkData: [],
      list: []
    }
  },
  methods: {
    change(val) {
      val = val.trim()
      if (val === this.keyword) return
      this.keyword = val
      if (this.keyword.length === 0) {
        this.wkData = []
        this.txkData = []
        this.list = []
        return
      }
      this.keyword = val
      getJpList(this.page, 100, this.keyword, '').then((res) => {
        let data = res.data
        if (data && data.code === RES_OK && data.data) {
          this.first = true
          this.wkData = []
          this.txkData = []
          this.list = []
          if (data.data.length) {
            data.data.forEach((item, index) => {
              if (item.data.length) {
                this.list.push(...item.data)
                // item.data.forEach(item2 => {
                //   if (item2.type === '微课') {
                //     this.wkData.push(item2)
                //   }
                //   if (item2.type === '体系课') {
                //     this.txkData.push(item2)
                //   }
                // })
              }
            })
          }
        }
      })
    }
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .content
    padding-top size(136)
    padding-bottom size(60)
    padding-left: size(30)
    padding-right: size(30)
  .search
    padding size(30)
    position fixed
    width 100%
    left 0
    top 0
    background #ffffff
    z-index 9
  .item
    padding size(40) size(30)
</style>



// WEBPACK FOOTER //
// src/components/jpff/search.vue